import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const EMAIL_REGEX =
    /^(?!.*\.\.)(?!\.)(?!.*\.$)[a-zA-Z0-9_%+'-]+(?:\.[a-zA-Z0-9_%+'-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

// validation function
export function emailValidator(): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
        let result = null;

        const isValid =
            c.value === undefined ||
            c.value === null ||
            c.value === '' ||
            EMAIL_REGEX.exec(c.value.trim());

        if (!isValid) {
            result = {
                email: {
                    valid: false
                }
            };
        }

        return result;
    };
}
